import { useEffect } from 'react';
import { useThirdPartyOAuth } from '@modules/settings/integrations/hooks/use-third-party-oauth';
import { TRANSIENT_TOKEN } from '@modules/settings/integrations/constants/integration.constants';
import Cookies from 'js-cookie';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useWorkspaceStatus } from '@shared/hooks/use-workspace-status';

export const useHandleOAuthSideEffects = () => {
  const location = useLocation();
  const { isSignUpCompleted } = useWorkspaceStatus();

  /**
   * Needs to revisit PipeDrive OAuth with FederatedSignUp feature
   */
  const isFederatedSignUpPage = location?.pathname == '/auth/callback';
  const [searchParams] = useSearchParams();
  const { handleExchangeViaTransientToken, handleCacheOAuth, handleExchangeOauthForToken } = useThirdPartyOAuth();
  const transientToken = Cookies.get(TRANSIENT_TOKEN);

  const thirdPartyOAuthCode = searchParams.get('code');

  // Cache OAuth code if not logged in
  useEffect(() => {
    if (!isSignUpCompleted && thirdPartyOAuthCode && !isFederatedSignUpPage) {
      handleCacheOAuth();
      handleExchangeOauthForToken();
    }
  }, [isSignUpCompleted, thirdPartyOAuthCode]);

  useEffect(() => {
    if (isSignUpCompleted && thirdPartyOAuthCode) {
      handleExchangeOauthForToken();
    }
  }, [isSignUpCompleted, thirdPartyOAuthCode]);

  // Exchange via transient token if logged in
  useEffect(() => {
    if (isSignUpCompleted && transientToken && !isFederatedSignUpPage) {
      handleExchangeViaTransientToken();
    }
  }, [isSignUpCompleted, transientToken]);
};
